// src/features/files/services/folders.js
import { apiClient } from '../../../services/api/client';

export const foldersAPI = {
  // Create folder
  createFolder: (data) => 
    apiClient.post('/api/v1/file/folders', data),

  // Get folder details
  getFolderDetails: (folderId) => 
    apiClient.get(`/api/v1/file/folders/${folderId}`),

  // Get root contents (folders + files at root level)
  getRootContents: () => 
    apiClient.get('/api/v1/file/folders/department/root'),

  // List subfolders
  listSubfolders: (folderId) => 
    apiClient.get(`/api/v1/file/folders/${folderId}/subfolders`),

  // Get folder tree
  getFolderTree: (rootFolderId = null) => {
    const url = rootFolderId 
      ? `/api/v1/file/folders/department/tree?root_folder_id=${rootFolderId}`
      : '/api/v1/file/folders/department/tree';
    return apiClient.get(url);
  },

  // Get folder contents (subfolders + files)
  getFolderContents: (folderId) => 
    apiClient.get(`/api/v1/file/folders/${folderId}/contents`),

  // Who may see and change the folder (needs file:permissions)
  getAccess: (folderId) =>
    apiClient.get(`/api/v1/file/folders/${folderId}/access`),

  setAccess: (folderId, { inherit, rules }) =>
    apiClient.put(`/api/v1/file/folders/${folderId}/access`, { inherit, rules }),

  // Update folder
  updateFolder: (folderId, data) => 
    apiClient.patch(`/api/v1/file/folders/${folderId}`, data),

  // Move folder
  moveFolder: (folderId, newParentFolderId) => 
    apiClient.post(`/api/v1/file/folders/${folderId}/move`, {
      new_parent_folder_id: newParentFolderId
    }),

  // What deleting a folder would remove, and its files that are still used elsewhere
  getFolderUsage: (folderId) =>
    apiClient.get(`/api/v1/file/folders/${folderId}/usage`),

  // Delete folder
  deleteFolder: (folderId, options = {}) => {
    const params = new URLSearchParams();
    if (options.force_physical_delete !== undefined) {
      params.append('force_physical_delete', options.force_physical_delete);
    }
    if (options.recursive !== undefined) {
      params.append('recursive', options.recursive);
    }
    
    const url = params.toString() 
      ? `/api/v1/file/folders/${folderId}?${params.toString()}`
      : `/api/v1/file/folders/${folderId}`;
    
    return apiClient.delete(url);
  },
};